import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PollListComponent } from './poll-list/poll-list.component';
import { PollPageComponent } from './poll-page/poll-page.component';
import { PollPostEditorComponent } from './poll-post-editor/poll-post-editor.component';
import { SlugComponent } from '@tytapp/slugs';

const routes: Routes = [
    { path: 'v1', component: PollListComponent },
    { path: 'all', component: PollListComponent },
    { path: ':pollSlug/posts/:postId', component: PollPostEditorComponent },
    { path: ':id/edit', loadChildren: () => import('../poll-editor-pages').then(m => m.PollEditorPagesModule) },
    { path: 'new', redirectTo: 'new/edit' },
    { path: ':id', component: PollPageComponent },
    SlugComponent.outlet('')
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
